export const PersonIcon = (props) => (
  <svg fill={props.color} height={`${props.size || 39}`} width={`${props.size || 39}`} viewBox="0 0 24 24">
    <g>
      <circle cx="11.99" cy="8.17" r="4.17" />
      <path d="M12 14a8.62 8.62 0 0 0-7.3 4.25 1.15 1.15 0 0 0 1 1.75h12.6a1.14 1.14 0 0 0 1-1.66A8.62 8.62 0 0 0 12 14z" />
    </g>
  </svg>
);
